
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class PmcSupplier extends SupplierForm {
  form = {
    // productPriceRange: "",
    newQuantityMonth: null as number | null,
    factoryInfo: {
      developmentInfo: {
        /** 是否具有研发能力 */
        developmentInfoAbility: false,
        /** 是否定期推荐新品 */
        recomNewPrdctReg: false,
        /** 月上新数 */
        newQuantityMonth: null as number | null,
        /** 月打版数 */
        printingQuantityMonth: null as number | null,
        /** 打版时效 */
        playVersionTime: null as number | null,
      },
    },
  };
  get rules(): ElementUIFormRules {
    return this.getFieldsRules([
      "factoryInfo.developmentInfo.developmentInfoAbility",
      "factoryInfo.developmentInfo.recomNewPrdctReg",
      "factoryInfo.developmentInfo.newQuantityMonth",
      "factoryInfo.developmentInfo.printingQuantityMonth",
      "factoryInfo.developmentInfo.playVersionTime",
    ]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
}
